// API 기본 URL을 반환하는 함수
export const getApiUrl = () => {
    const hostname = window.location.hostname;
    return `https://${hostname}/api`;
    //return `https://unicheck.dsti.co.kr/api`;
    //return 'https://dev.smartdesco.co.kr/api';
    //return `https://khu.unicheck.co.kr/api`;
    //return `http://211.50.136.51:8081/api`;
    //return `http://localhost:8080/api`;
    //return `http://54.180.48.141/api`;
}

// 통계(대시보드) API URL - statistics 엔드포인트가 있는 서버
export const getStatisticsApiUrl = () => {
    const hostname = window.location.hostname;
    return `https://${hostname}/api`;
    //return 'https://dev.smartdesco.co.kr/api';
    //return `https://unicheck.dsti.co.kr/api`;
}

// 이미지 기본 URL을 반환하는 함수
export const getImageBaseUrl = () => {
    const hostname = window.location.hostname;
    return `https://${hostname}`;
    //return `https://unicheck.dsti.co.kr` //회사서버
    //return 'https://dev.smartdesco.co.kr';
    //return `https://khu.unicheck.co.kr`; //경희대 서버
    //return `http://211.50.136.51:8081`;
    //return `http://localhost:8080`;
    //return `http://54.180.48.141`;
}

// API가 아닌 기본 URL을 반환하는 함수
export const getNoApiBaseUrl = () => {
    const hostname = window.location.hostname;
    return `https://${hostname}`;
    //return `https://unicheck.dsti.co.kr`;
    //return 'https://dev.smartdesco.co.kr';
    //return `https://khu.unicheck.co.kr`;
    //return `http://211.50.136.51:8081`;
    //return `http://localhost:8080`;
    //return `http://54.180.48.141`;
}

// 백엔드에서 보내는 에러 메시지 알림내용 표시
export const handleApiError = (error) => {
    if (error.response && error.response.data && error.response.data.message) {
        alert(error.response.data.message);
    }
};
